import React from 'react';
import { Link } from 'react-router-dom';


const Synergy = (props) => {

  return (
    <div className="sidebar-component">
            <div className="flex-between">
                <Link to="/synergy">
                    <p data-component="provider">
                        SYNERGY
                    </p>
                </Link>
            </div>
        </div>
  );
};

export default Synergy;
